import {
  AWS_V2_OIDC_AUDIENCE,
  AZURE_V2_OIDC_AUDIENCE,
  GCP_V2_OIDC_AUDIENCE,
  VAULT_V2_OIDC_AUDIENCE
} from '@env0/common-oidc';
import type { OidcTokenFormat } from '@env0/common-oidc';
import { auth0Audience } from 'constants/config';
import { CredentialType } from 'types/api.types';

const oidcTypeToV2Audience: Partial<Record<CredentialType, string>> = {
  [CredentialType.AWS_OIDC]: AWS_V2_OIDC_AUDIENCE,
  [CredentialType.AZURE_OIDC]: AZURE_V2_OIDC_AUDIENCE,
  [CredentialType.GCP_OIDC]: GCP_V2_OIDC_AUDIENCE,
  [CredentialType.VAULT_OIDC]: VAULT_V2_OIDC_AUDIENCE
};

export const getOidcAudience = (type: CredentialType, tokenFormat?: OidcTokenFormat): string =>
  tokenFormat === 'v2' ? (oidcTypeToV2Audience[type] ?? auth0Audience) : auth0Audience;
